Vue.component('navigation-handler', require('./../src/components/Navigation/NavigationHandler.vue'));
Vue.component('navigation', require('./../src/components/Navigation/Navigation.vue'));

Vue.component('cookie-consent', require('./../src/components/Cookie/CookieConsent.vue'));
Vue.component('cookie-setup', require('./../src/components/Cookie/CookieSetup.vue'));
Vue.component('share-buttons', require('./../src/components/ShareButtons.vue'));
Vue.component('search-form', require('./../src/components/Search/SearchForm.vue'));
Vue.component('search-trigger', require('./../src/components/Search/SearchTrigger.vue'));
Vue.component('ssd-paginator', require('./../src/components/Paginator/Select.vue'));

Vue.component('change-reveal', require('./../src/components/Reveal/Change.vue'));
Vue.component('toggle-reveal', require('./../src/components/Reveal/Toggle.vue'));

Vue.component('video-slide', require('./../src/components/VideoSlide.vue'));
Vue.component('map-box', require('./../src/components/Map/MapBox.vue'));


// WEBPACK FOOTER //
// ./resources/js/front/components.js